<template>
  <v-container>
    <v-layout justify-center wrap>
      <v-flex xs12 sm10 md8 lg6>
        <v-row justify="center">
          <v-snackbar
            v-model="snackbar"
            color="accent"
            :timeout="timeout"
            bottom
          >
            {{ alertText }}
            <v-btn dark text @click="snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
        </v-row>
        <v-card class="mx-auto my-12 rounded" max-width="600">
          <v-card-title class="text-center">Profile</v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
              <v-container>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field
                      class="purple-input"
                      label="UserName"
                      :rules="nameRules"
                      :counter="50"
                      v-model="displayName"
                    />
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field
                      label="Email"
                      v-model="email"
                      readonly
                      class="purple-input"
                    />
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field
                      label="Mobile/Phone Number"
                      v-model="phNumber"
                      :rules="phRules"
                      type="number"
                      class="purple-input"
                    />
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field
                      label="Address"
                      v-model="address"
                      class="purple-input"
                    />
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field
                      label="City"
                      v-model="city"
                      :rules="cityRules"
                      class="purple-input"
                    />
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-select
                      v-model="country"
                      :items="countries"
                      :rules="[v => !!v || 'Country is required']"
                      label="Select your country"
                      color="primary"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field
                      class="purple-input"
                      label="Postal Code"
                      type="number"
                      v-model="postalCode"
                    />
                  </v-flex>
                  <v-flex xs12 text-center>
                    <v-btn
                      class="mx-0 font-weight-light rounded"
                      color="primary"
                      @click="validate"
                      :disabled="clicked"
                    >
                      {{ btnText }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { functions } from "@/Firebase";
export default {
  name: "Profile",
  data: () => ({
    snackbar: false,
    valid: false,
    timeout: 25000,
    lazy: false,
    displayName: "",
    btnText: "UPDATE PROFILE",
    clicked: false,
    nameRules: [
      v => !!v || "Name is required",
      v => (v && v.length <= 50) || "Name must be less than 50 characters"
    ],
    cityRules: [v => !!v || "City is required"],
    phRules: [v => !!v || "Phone Number is required"],
    email: "",
    phNumber: "",
    address: "",
    city: "",
    country: "",
    countries: [
      "India",
      "Afghanistan",
      "Albania",
      "Algeria",
      "Andorra",
      "Angola",
      "Anguilla",
      "Antigua &amp; Barbuda",
      "Argentina",
      "Armenia",
      "Aruba",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Bosnia &amp; Herzegovina",
      "Botswana",
      "Brazil",
      "British Virgin Islands",
      "Brunei",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Cape Verde",
      "Cayman Islands",
      "Chad",
      "Chile",
      "China",
      "Colombia",
      "Congo",
      "Cook Islands",
      "Costa Rica",
      "Cote D Ivoire",
      "Croatia",
      "Cruise Ship",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Estonia",
      "Ethiopia",
      "Falkland Islands",
      "Faroe Islands",
      "Fiji",
      "Finland",
      "France",
      "French Polynesia",
      "French West Indies",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Greenland",
      "Grenada",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea Bissau",
      "Guyana",
      "Haiti",
      "Honduras",
      "Hong Kong",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kuwait",
      "Kyrgyz Republic",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Macau",
      "Macedonia",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Mauritania",
      "Mauritius",
      "Mexico",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Namibia",
      "Nepal",
      "Netherlands",
      "Netherlands Antilles",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Norway",
      "Oman",
      "Pakistan",
      "Palestine",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Reunion",
      "Romania",
      "Russia",
      "Rwanda",
      "Saint Pierre &amp; Miquelon",
      "Samoa",
      "San Marino",
      "Satellite",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "South Africa",
      "South Korea",
      "Spain",
      "Sri Lanka",
      "St Kitts &amp; Nevis",
      "St Lucia",
      "St Vincent",
      "St. Lucia",
      "Sudan",
      "Suriname",
      "Swaziland",
      "Sweden",
      "Switzerland",
      "Syria",
      "Taiwan",
      "Tajikistan",
      "Tanzania",
      "Thailand",
      "Timor L'Este",
      "Togo",
      "Tonga",
      "Trinidad &amp; Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Turks &amp; Caicos",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "United States",
      "Uruguay",
      "Uzbekistan",
      "Venezuela",
      "Vietnam",
      "Virgin Islands (US)",
      "Yemen",
      "Zambia",
      "Zimbabwe"
    ],
    postalCode: "",
    photoUrl: "",
    alertText: ""
  }),
  created() {
    this.displayName = this.$store.getters.displayName;
    this.email = this.$store.getters.email;
    this.phNumber = this.$store.getters.phNumber;
    this.address = this.$store.getters.address;
    this.city = this.$store.getters.city;
    this.country = this.$store.getters.country;
    this.postalCode = this.$store.getters.postalCode;
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.clicked = true;
        this.btnText = "PLEASE WAIT UPDATING";
        let uid = this.$store.state.userId;
        var updateProfile = functions.httpsCallable("updateProfile");
        updateProfile({
          uid: uid,
          displayName: this.displayName,
          phNumber: this.phNumber,
          address: this.address,
          city: this.city,
          country: this.country,
          postalCode: this.postalCode
        }).then(() => {
          this.clicked = false;
          this.btnText = "UPDATE PROFILE";
          this.$store.commit("addDisplayName", this.displayName);
          this.$store.commit("addPhNumber", this.phNumber);
          this.$store.commit("addAddress", this.address);
          this.$store.commit("addCity", this.city);
          this.$store.commit("addCountry", this.country);
          this.$store.commit("addPostalCode", this.postalCode);
          this.alertText = "Profile Updated";
          this.snackbar = true;
        });
      }
    }
  }
  //
};
</script>
